'use client';

import { useEffect } from 'react';

export function SurveyServiceWorkerRegistrar() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const base = process.env.NEXT_PUBLIC_ASSET_BASE_PATH ?? '';
    // Non-prod registers a passthrough SW (no static caching) so it stays testable without poisoning dev HMR.
    const query = process.env.NODE_ENV === 'production' ? '' : '?swcache=off';
    try {
      navigator.serviceWorker.register(`${base}/sw.js${query}`).catch(() => {
        // SW registration is best-effort; the app works without it
      });
    } catch {
      // An opaque-origin document throws SecurityError on the property read itself, which no promise handler sees.
    }
  }, []);

  return null;
}
